export default {
  ARTICLE: 'block-text saleTop',
  WRAP: 'qvh24--pdp2',
  BIG_IMAGE: 'qvh24--pic',
  SLIDER: {
    WRAP: 'qvh24--swiper',
    ARROWUP: 'qvh24--swiper-up',
    ARROWDOWN: 'qvh24--swiper-down',
    INNERWRAP: {
      WRAP: 'swiper-container',
      IMG: {
        WRAP: 'swiper-wrapper',
        INNERWRAP: 'swiper-slide',
        STANDARD: 'qvh24-mini-pic',
        ACTIVE:
          'qvh24-mini-pic-active gallery-qv__small-img js-quick-view__small-img gallery-qv__small-img--active'
      }
    }
  },
  DETAILS: {
    WRAP: 'qvh24--details',
    TITLE: {
      HEADLINE:
        'qvh24--headline article-qv__name js-quick-view__pdp-link acte-quick-view__article-name',
      SUBLINE: 'qvh24--subline article-qv__variant'
    },
    STARS: {
      WRAP: 'qvh24--stars',
      INNER: 'qvh24--staroutside stars-empty',
      INSIDE: 'stars-full',
      RATING: 'article-qv__ranking-amount'
    },
    PRICE: {
      WRAP: 'qvh24--pricewrap article__price-wrap article-qv__price-wrap',
      NORMAL: 'article__price',
      STRIKE: 'article__price  article__price--new',
      DISCOUNT: 'article__price-old'
    },
    DELIVERY: {
      NORMAL: 'qvh24--lieferzeitwrap article-qv__delivery ',
      FAST:
        'qvh24--lieferzeitwrap article-qv__delivery  article__delivery--fast '
    },
    BUTTONS: {
      WRAP: 'qvh24--buttons-wrap',
      ADD_TO_CART:
        'qvh24--buy-button button button--primary button--big js-add-to-cart-button acte-quick-view__add-to-cart',
      GO_TO_PRODUCTPAGE:
        'qvh24--product-page-button button js-quick-view__pdp-link acte-quick-view__product-details'
    },
    OPTIONS: {
      WRAPHEADER: 'mvc-qv__item acte-quick-view__mvc-item',
      LABEL: 'mvc-qv__label',
      WRAPOPTIONS: 'select-primary select--full-width',
      SELECT: 'qvh24--select acte-quick-view__mvc-item-select'
    }
  },
  NOTIFICATION: {
    WRAP:
      'quick-view__change-notification quick-view__change-notification--active',
    IMG: 'quick-view__change-notification__icon',
    INNER: 'quick-view__change-notification__content'
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/constants/classNames-swiper.js
 **/